import * as Yup from 'yup';
import getLangData from '../../../utils/getLangData';

const Schema = () =>
  Yup.object({
    /*     geolocation: Yup.array().of(Yup.number()).default([30.093529617886073,31.340912898477427]),
     */
    artisanCID: Yup.string(),
    // .required(getLangData().fields.required),
    supplierCID: Yup.string(),
    // .required(getLangData().fields.required),
    tcBIO: Yup.string().default('').required(getLangData().fields.required),

    tcBIOi18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default(''),
    }).nullable(),

    businessName: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    businessNamei18n: Yup.object({
      arabic_ar: Yup.string().default(''),
      chinese_zh_man: Yup.string().default(''),
      chinese_zh_can: Yup.string().default(''),
      deutsch_de: Yup.string().default(''),
      espanol_es: Yup.string().default(''),
      français_fr: Yup.string().default(''),
      hindi_hi: Yup.string().default(''),
      indonesian_id: Yup.string().default(''),
      italiano_it: Yup.string().default(''),
      japanese_ja: Yup.string().default(''),
      korean_ko: Yup.string().default(''),
      portugues_pt: Yup.string().default(''),
      russian_ru: Yup.string().default(''),
      turkish_tr: Yup.string().default(''),
    }).nullable(),
    // businessType: Yup.array()
    // 	.of(Yup.string())
    // 	.default(["0"])
    // 	.required(getLangData().fields.required),
    yearEstablished: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    regCompany: Yup.bool().default(false),
    // companySize: Yup.string().default("1-10"),
    profileType: Yup.string()
      .default('')
      .required(getLangData().fields.required),
    logo: Yup.string().default(''),
    website: Yup.string().default(''),
    facebook: Yup.string().default(''),
    youtube: Yup.string().default(''),
    instagram: Yup.string().default(''),

    status: Yup.bool().default(true),

    workingHours: Yup.object({
      // days
      monday: Yup.bool().default(false),
      tuesday: Yup.bool().default(false),
      wednesday: Yup.bool().default(false),
      thursday: Yup.bool().default(false),
      friday: Yup.bool().default(false),
      saturday: Yup.bool().default(false),
      sunday: Yup.bool().default(false),

      // from
      mondayF: Yup.string().default('0000'),
      tuesdayF: Yup.string().default('0000'),
      wednesdayF: Yup.string().default('0000'),
      thursdayF: Yup.string().default('0000'),
      fridayF: Yup.string().default('0000'),
      saturdayF: Yup.string().default('0000'),
      sundayF: Yup.string().default('0000'),

      // to
      mondayT: Yup.string().default('0000'),
      tuesdayT: Yup.string().default('0000'),
      wednesdayT: Yup.string().default('0000'),
      thursdayT: Yup.string().default('0000'),
      fridayT: Yup.string().default('0000'),
      saturdayT: Yup.string().default('0000'),
      sundayT: Yup.string().default('0000'),
    }),

    contactPerson: Yup.string().default('').required(getLangData().fields.required),

    contactPersonTitle: Yup.string().default('').required(getLangData().fields.required),

    contactPersonPhone: Yup.string().default('').required(getLangData().fields.required),

    contactPersonEmail: Yup.string().default('').required(getLangData().fields.required),
  });

export default Schema;
